import React from "react";
import { Layout, usePermissions } from "react-admin";
import { Redirect, useLocation } from "react-router-dom";
import CustomAppBar from "./customAppBar";
import Menu from "./newSideMenu";
import { hasSimpleProductsOnlyAccess } from "../components/Users/userRoleUtils";

const ALLOWED_PATH_PREFIXES = [
  "/simple-products",
  "/simple-product-categories",
  "/simple-product-lines",
  "/components",
  "/profile",
  "/change-password",
];

const isAllowedSimpleProductsPath = (pathname) =>
  ALLOWED_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );

const CustomLayout = (props) => {
  const { permissions, loaded } = usePermissions();
  const location = useLocation();

  if (
    loaded &&
    hasSimpleProductsOnlyAccess(permissions) &&
    !isAllowedSimpleProductsPath(location.pathname)
  ) {
    return <Redirect to="/simple-products" />;
  }

  return <Layout {...props} appBar={CustomAppBar} menu={Menu} />;
};

export default CustomLayout;
